import { ReactNode } from 'react';

import { validateUser } from '~/services/api/auth';
import { getUserById } from '~/services/api/users';

import Footer from './footer';
import Header from './header';

export interface LayoutProps {
  user:
    | NonNullable<Awaited<ReturnType<typeof getUserById>>>
    | NonNullable<Awaited<ReturnType<typeof validateUser>>['user']>;
  children: ReactNode;
}

export default function Layout({ user, children }: LayoutProps) {
  return (
    <div className="flex h-fit min-h-screen w-screen flex-col">
      <Header user={user} />
      <main className="container mx-auto flex flex-1 flex-col gap-4 overflow-hidden py-5 lg:gap-6">{children}</main>
      <Footer user={user} />
    </div>
  );
}
